/** @jsxImportSource @emotion/react */

import { Typography } from '@mui/material'

import { round } from 'lodash'
import { pluralize } from 'utils/pluralize'

import { DateOption } from '../consts'
import * as classes from './styles'

const format = (value: number) => round(value, 2).toLocaleString('en-US')

type Props = {
  selectedDate: DateOption
  totalUsed: number
  totalRevenue: number
}

export const TextStatistics = ({ totalUsed, totalRevenue, selectedDate }: Props) => (
  <div css={classes.statisticsWrapper}>
    <div css={[classes.statisticsRow, classes.firstRow]}>
      <Typography variant="h6" css={classes.statisticsBlockTitle}>
        Detail Statistics
      </Typography>

      <Typography variant="body1" css={classes.statisticValue}>
        {selectedDate.title}
      </Typography>
    </div>
    <div css={classes.statisticsBlock}>
      <div css={classes.statisticsRow}>
        <Typography variant="body1" css={classes.statisticLabel}>
          Total Code Used
        </Typography>
        <Typography variant="body1" css={classes.statisticValue}>
          {totalUsed} {pluralize(totalUsed, 'time')}
        </Typography>
      </div>

      <div css={classes.statisticsRow}>
        <Typography variant="body1" css={classes.statisticLabel}>
          Total Revenue:
        </Typography>
        <Typography variant="body1" css={classes.statisticValue}>
          ${format(totalRevenue)} USD
        </Typography>
      </div>
    </div>

    <Typography variant="h6" css={classes.statisticsBlockTitle}>
      Influencer Earnings
    </Typography>
    <div css={classes.statisticsBlock}>
      <div css={classes.statisticsRow}>
        <Typography variant="body1" css={classes.statisticLabel}>
          10% of total billed:
        </Typography>
        <Typography variant="body1" css={classes.statisticValue}>
          ${format(totalRevenue * 0.1)} USD
        </Typography>
      </div>

      <div css={classes.statisticsRow}>
        <Typography variant="body1" css={classes.statisticLabel}>
          8% of total billed:
        </Typography>
        <Typography variant="body1" css={classes.statisticValue}>
          ${format(totalRevenue * 0.08)} USD
        </Typography>
      </div>

      <div css={classes.statisticsRow}>
        <Typography variant="body1" css={classes.statisticLabel}>
          6% of total billed:
        </Typography>
        <Typography variant="body1" css={classes.statisticValue}>
          ${format(totalRevenue * 0.06)} USD
        </Typography>
      </div>
    </div>
  </div>
)
